<template>
  <div id="qrcode" ref="qrcode"></div>
</template>
<script>
import QRCode from "qrcodejs2";
export default {
  props: ["param", "size"],
  data() {
    return {
      msg: "hello vue",
      codes: "",
    };
  },
  methods: {
    useqrcode() {
      this.$refs.qrcode.innerHTML = "";
      new QRCode(this.$refs.qrcode, {
        text: this.param,
        width: this.size || 130,
        height: this.size || 130,
        colorDark: "#000000",
        colorLight: "#ffffff",
        margin: 0,
        correctLevel: QRCode.CorrectLevel.L,
      });
    },
  },

  mounted() {
    // console.log(this.param)
    this.useqrcode();
  },
};
</script>
<style lang="less" scoped>
#qrCode {
  height: 100%;
  padding: 10px;
  position: relative;
  text-align: center;
  .canvas-container {
    // background-color: @white;
  }
  #canvas {
    width: 200px !important;
    height: auto !important;
  }
}
</style>
